import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-78ef37c2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sp" }
const _hoisted_2 = { class: "sp__elm" }
const _hoisted_3 = /*#__PURE__*/_createStaticVNode("<div class=\"sp__elm-item\" data-v-78ef37c2><div class=\"sp__elm-item-label\" data-v-78ef37c2>Текущий пароль:</div><div class=\"sp__elm-item-input\" data-v-78ef37c2><input type=\"password\" class=\"sp__elm-item-input-password\" placeholder=\"Введите пароль\" data-v-78ef37c2></div></div><div class=\"sp__elm-item\" data-v-78ef37c2><div class=\"sp__elm-item-label\" data-v-78ef37c2>Новый пароль:</div><div class=\"sp__elm-item-input\" data-v-78ef37c2><input type=\"password\" class=\"sp__elm-item-input-password\" placeholder=\"Введите пароль\" data-v-78ef37c2></div></div><div class=\"sp__elm-item\" data-v-78ef37c2><div class=\"sp__elm-item-label\" data-v-78ef37c2>Новый пароль ещё раз:</div><div class=\"sp__elm-item-input\" data-v-78ef37c2><input type=\"password\" class=\"sp__elm-item-input-password\" placeholder=\"Введите пароль\" data-v-78ef37c2></div></div><div class=\"sp__elm-line\" data-v-78ef37c2></div>", 4)
const _hoisted_7 = { class: "sp__elm-item" }
const _hoisted_8 = { class: "sp__elm-item-btn" }
const _hoisted_9 = { class: "sp__elm-item-exit" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sp__elm-item-exit-label" }, "Выйти", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_UiButton = _resolveComponent("UiButton")!
  const _component_IconExit = _resolveComponent("IconExit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_UiButton, {
            label: "Изменить пароль",
            "background-color": "var(--theme-color)",
            "border-color": "var(--theme-color)",
            color: "rgb(255, 255, 255)",
            "font-weight": "600",
            "font-size": "16px"
          })
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createVNode(_component_IconExit, { color: "rgb(119, 121, 124)" }),
          _hoisted_10
        ])
      ])
    ])
  ]))
}